<template>
  <div class="content" style="overflow: hidden">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="blue">
          <template slot="header">
            <md-icon>person</md-icon>
          </template>
          <template slot="content">
            <p class="category">Users</p>
            <h3 class="title">{{ stats.activeUsersCount }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <a
                @click.prevent="showAddUser = isWritable"
                :class="{
                  'cursor-class': isWritable,
                  'show-add-user-deleted-app': !isWritable,
                }"
              >
                <md-icon>add</md-icon>
                Add new user
              </a>
            </div>
          </template>
        </stats-card>
      </div>
      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="orange">
          <template slot="header">
            <md-icon>support_agent</md-icon>
          </template>

          <template slot="content">
            <p class="category">Admins</p>
            <h3 class="title">
              {{ stats.applicationAdminsCount }}
              <small>
                <a
                  @click.prevent="
                    showAppAdmins = true;
                    addListAdmins = false;
                  "
                  style="cursor: pointer"
                >
                  <md-tooltip md-direction="top"> Show list of admins</md-tooltip>
                  <md-icon style="font-size: 16px !important">launch</md-icon>
                </a>
              </small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <a
                @click.prevent="
                  showAppAdmins = isWritable;
                  addListAdmins = isWritable;
                "
                :class="{
                  'cursor-class': isWritable,
                  'show-add-user-deleted-app': !isWritable,
                }"
              >
                <md-icon>add</md-icon>
                Add new admin
              </a>
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="green">
          <template slot="header">
            <md-icon>assignment_turned_in</md-icon>
          </template>

          <template slot="content">
            <p class="category">Successful Auth.</p>
            <h3 class="title">
              {{ (stats.allowRatio * 100).toFixed(2) }}
              <small>%</small>
            </h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>keyboard_arrow_right</md-icon>
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports',
                  query: {
                    application_id: this.applicationId,
                    application__name: this.application.name,
                  },
                }"
                >Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-25 stat-card">
        <stats-card data-background-color="red">
          <template slot="header">
            <md-icon>assignment_late</md-icon>
          </template>

          <template slot="content">
            <p class="category">Frauds</p>
            <h3 class="title">{{ stats.fraudCount }}</h3>
          </template>

          <template slot="footer">
            <div class="stats">
              <md-icon>keyboard_arrow_right</md-icon>
              <router-link
                :to="{
                  name: 'Authentication/Authorization Reports',
                  query: {
                    application_id: this.applicationId,
                    application__name: this.application.name,
                  },
                }"
                >Proceed to Logs
              </router-link>
            </div>
          </template>
        </stats-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60">
        <nav-tabs-card>
          <template slot="content">
            <span class="md-nav-tabs-title">Application Configuration</span>
            <md-tabs class="md-primary" md-alignment="right">
              <md-tab id="tab-home" md-label="General" md-icon="settings">
                <div class="md-layout-item md-size-100 md-size-33">
                  <md-field>
                    <label>Application Name</label>
                    <md-input :disabled="!isWritable" v-model="application.name" type="text" required></md-input>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 md-size-33">
                  <md-field :class="originIPMessageClass">
                    <label>Origin IP Network</label>
                    <md-input :disabled="!isWritable" v-model="application.originIpNetwork" type="text"></md-input>
                    <span class="md-error">{{ originIPErrorMessage }}</span>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <md-checkbox :disabled="!isWritable" v-model="application.caseSensitive"
                      >Case Sensitive Usernames</md-checkbox
                    >
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100">
                  <md-field>
                    <md-checkbox v-model="enableNormalizationUsernames">Normalization Usernames</md-checkbox>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100" v-if="enableNormalizationUsernames">
                  <md-field :class="normalizationPatternClass">
                    <label>Enter an regex pattern to normalize usernames</label>
                    <md-input v-model="application.normalizationPattern" :disabled="!isWritable" type="text"></md-input>
                    <span class="md-error">{{ normalizationPatternErrorMessage }}</span>
                  </md-field>
                </div>                

                <div class="md-layout-item md-size-100">
                  <md-field maxlength="5">
                    <label>Application Description</label>
                    <md-textarea v-model="application.description" :disabled="!isWritable"></md-textarea>
                  </md-field>
                </div>
                <div class="md-layout-item md-size-100 text-right">
                  <md-button class="md-raised md-primary" @click="editApplication" v-if="isWritable">
                    Update
                  </md-button>
                </div>
              </md-tab>

              <md-tab id="tab-pages" md-label="Policies" md-icon="policy">
                <policy-table
                  :query="{ applicationPk: applicationId }"
                  :scopeName="application.name"
                  :isDeletedApplication="application.isDeleted"
                ></policy-table>
              </md-tab>
            </md-tabs>
          </template>
        </nav-tabs-card>
      </div>

      <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-40">
        <md-card class="md-card-profile">
          <application-logo :enable-upload="isWritable" :application_id="applicationId"></application-logo>
          <md-card-content>
            <h6 class="category text-gray">Auth API</h6>
            <h4 class="card-title">{{ application.name }}</h4>
            <md-subheader>Ikey</md-subheader>

            <md-list-item>
              <md-icon class="md-primary">vpn_key</md-icon>

              <div class="md-list-item-text">
                <code>{{ application.ikey }}</code>
              </div>

              <md-button id="ikey_button" class="md-icon-button md-list-action" @click="copyKey('ikey_button')">
                <md-icon>file_copy</md-icon>
              </md-button>
            </md-list-item>
            <md-subheader>skey</md-subheader>

            <md-list-item>
              <md-icon class="md-primary" :class="!isWritable ? 'disabled-text' : ''">vpn_key</md-icon>

              <div class="md-list-item-text">
                <span v-if="showSkey" class="skey">
                  <code>{{ application.skey }}</code>
                </span>
                <span :class="!isWritable ? 'disabled-text' : ''" v-else>
                  Click on the lock open to show secrete key
                </span>
              </div>

              <md-button
                :disabled="!isWritable"
                id="skey_button"
                class="md-icon-button md-list-action"
                @click="copyKey('skey_button')"
              >
                <md-icon>file_copy</md-icon>
              </md-button>
              <md-button :disabled="!isWritable" class="md-icon-button md-list-action" @click="toggleShowSkey">
                <md-icon>lock_open</md-icon>
              </md-button>
            </md-list-item>
            <md-button class="md-primary" @click="deleteApplication(applicationId)" v-if="isWritable">
              <md-icon>delete</md-icon>
              Delete Application
            </md-button>
          </md-card-content>
        </md-card>
        <md-card class="security-card">
          <md-card-content>
            <md-subheader>MFA Settings</md-subheader>
            <md-list-item>
              <policy-slider :disabled="!isWritable" v-model="policy"></policy-slider>
              <md-button :disabled="!isWritable" class="md-icon-button md-list-action" @click="setPolicy">
                <md-icon>save</md-icon>
              </md-button>
            </md-list-item>
          </md-card-content>
        </md-card>
      </div>
    </div>
    <create-new-user :selectedApplicationId="applicationId" :show="showAddUser" @close="userCreated"></create-new-user>
    <application-admins
      :add_list="addListAdmins"
      :application_id="applicationId"
      :show="showAppAdmins"
      @close="adminAdded"
    >
    </application-admins>
    <delete-dialog
      :show="showDeleteDialog"
      delete-api-name="deleteApplication"
      title="Delete Application"
      message="This action deletes this application permanently, Are you sure?"
      :request-body="{ application_pk: deleteDialogKey }"
      @close="
        showDeleteDialog = false;
        deleteDialogKey = null;
      "
      @deleted="
        showDeleteDialog = false;
        deleteDialogKey = null;
        getApplication();
      "
    ></delete-dialog>
    <conflicted-users-dialog
      :show="showConflictUsersDialog"
      :conflictedUsers="conflictedUsersList"
      :numberOfConflictedUsers="numberOfConflictedUsers"
      @close="showConflictUsersDialog = false"
      @refresh="
        showConflictUsersDialog = false;
        editApplication();
      "
    ></conflicted-users-dialog>
    <invalidated-users-dialog
      :show="showInvalidatedUsersDialog"
      :invalidatedUsers="invalidatedUsersList"
      :numberOfinvalidatedUsers="numberOfInvalidatedUsers"
      @close="showInvalidatedUsersDialog = false"
      @refresh="
        showInvalidatedUsersDialog = false;
        editApplication();
      "
    ></invalidated-users-dialog>
  </div>
</template>
<script>
import fetchErrorHandler from "../../error.js";
import { ApplicationAdmins, ApplicationLogo, CreateNewUser, StatsCard, NavTabsCard } from "@/components";
import PolicySlider from "@/components/PolicySlider";
import PolicyTable from "@/components/Policies/PolicyTable";
import validateIPRange from "../../validators/validateIPRange";
import DeleteDialog from "../../components/DeleteDialog";
import ConflictedUsersDialog from "@/components/Applications/ConflictedUsersDialog";
import InvalidatedUsersDialog from "@/components/Applications/InvalidatedUsersDialog";
import snakeCaseObjectKeysToCamelCase from "../../utils/snakeCaseObjectKeysToCamelCase";
import { computed, onMounted, ref } from "@vue/composition-api";
import apiManager from "../../api-manager";

export default {
  name: "application-details",

  components: {
    PolicySlider,
    StatsCard,
    ApplicationLogo,
    CreateNewUser,
    ApplicationAdmins,
    DeleteDialog,
    NavTabsCard,
    PolicyTable,
    ConflictedUsersDialog,
    InvalidatedUsersDialog,
  },

  setup(props, { root }) {
    const application = ref({});
    const stats = ref({});
    const applicationId = ref(root.$route.query.application_id);
    const enableNormalizationUsernames = ref(false);

    const getApplication = async () => {
      applicationId.value = root.$route.query.application_id;

      const response = await apiManager.getApplicationDetails({
        params: {
          application_pk: applicationId.value,
        },
      });
      if (response.status !== 200) {
        fetchErrorHandler(response.status, response.statusText, root.$options.name);
        return;
      }

      application.value = snakeCaseObjectKeysToCamelCase(response.parsedData);
      stats.value = snakeCaseObjectKeysToCamelCase(response.parsedData.stats);
      enableNormalizationUsernames.value = !!application.value.normalizationPattern;
    };

    const originIPErrorMessage = ref(null);
    const normalizationPatternErrorMessage = ref(null);

    const editApplication = async () => {
      if (application.value.originIpNetwork && !validateIPRange(application.value.originIpNetwork)) {
        originIPErrorMessage.value = "Invalid IP address, use *.*.*.* or *.*.*.*/* format";
        return;
      }
      if (!application.value.name) {
        return;
      }
      if (enableNormalizationUsernames.value && !application.value.normalizationPattern) {
        normalizationPatternErrorMessage.value = "The regex normalization pattern is required";
        return;
      }
      if (enableNormalizationUsernames.value && !isValidRegex(application.value.normalizationPattern)) {
        normalizationPatternErrorMessage.value = "Invalid regex normalization pattern!";
        return;
      }
      if (!enableNormalizationUsernames.value) {
        application.value.normalizationPattern = null;
      }
     
      const response = await apiManager.editApplication({
        params: {
          application_pk: applicationId.value,
          name: application.value.name,
          description: application.value.description,
          origin_ip_network: application.value.originIpNetwork,
          case_sensitive: application.value.caseSensitive,
          normalization_pattern: application.value.normalizationPattern,
        },
      });
      if (response.status === 401) {
        fetchErrorHandler(response.status, response.statusText, root.$options.name);
      } else if (response.status === 400 && response.data.message_detail === "conflict in usernames") {
        conflictedUsersList.value = response.parsedError.users_with_conflict;
        numberOfConflictedUsers.value = response.parsedError.users_with_conflict_count;
        showConflictUsersDialog.value = true;
      } else if (response.status === 400 && response.data.message_detail === "usernames invalidated") {
        errorNotifyVue("top", "right", "Some usernames will be invalid after saving the normalization pattern." );
        invalidatedUsersList.value = response.parsedError.invalidated_usernames;
        numberOfInvalidatedUsers.value = response.parsedError.invalidated_usernames_count;
        showInvalidatedUsersDialog.value = true;
      } else if (response.status === 400 && response.data.message_detail === "normalization_pattern") {
        errorNotifyVue("top", "right", "Invalid regex normalization pattern");
      } else if (response.status === 200) {
        originIPErrorMessage.value = null;
        normalizationPatternErrorMessage.value = null;
        notifyVue("top", "right", "Successfully updated! ");
        await getApplication();
      }
    };

    const showSkey = ref(false);
    const toggleShowSkey = async () => {
      if (!showSkey.value) {
        const response = await apiManager.getApplicationSkey({ params: { application_pk: applicationId.value } });
        if (response.status !== 200) {
          fetchErrorHandler(response.status, response.statusText, root.$options.name);
          return;
        }
        application.value.skey = response.parsedData.skey;
      }
      showSkey.value = ~showSkey.value;
    };
    const copyKey = async (elem) => {
      let key;

      if (elem === "ikey_button") {
        key = application.value.ikey;
      } else if (elem === "skey_button") {
        const response = await apiManager.getApplicationSkey({ params: { application_pk: applicationId.value } });
        if (response.status !== 200) {
          fetchErrorHandler(response.status, response.statusText, root.$options.name);
          return;
        }
        key = response.parsedData.skey;
      }

      try {
        await navigator.clipboard.writeText(key);
        notifyVue("top", "right", "Successfully copied!");
      } catch {
        /* */
      }
    };

    const showDeleteDialog = ref(false);
    const deleteDialogKey = ref(null);
    const deleteApplication = async (applicationPK) => {
      showDeleteDialog.value = true;
      deleteDialogKey.value = applicationPK;
    };

    const policy = ref("");
    const getPolicies = async () => {
      const response = await apiManager.getPolicies({ params: { application_pk: applicationId.value } });
      if (response.status !== 200) {
        fetchErrorHandler(response.status, response.statusText, "ApplicationDetails");
        return;
      }

      policy.value = response.parsedData.action === "allow" ? "bypass" : response.parsedData.action;
    };
    const setPolicy = async () => {
      const response = await apiManager.setPolicy({
        params: {
          application_pk: applicationId.value,
          action: policy.value === "bypass" ? "allow" : policy.value,
        },
      });

      if (response.status === 200) {
        notifyVue("top", "right", "Successfully updated!");
      } else {
        errorNotifyVue("top", "right", "Error occurred on updating configuration!");
      }
    };

    const showAppAdmins = ref(false);
    const adminAdded = () => {
      showAppAdmins.value = false;
      getApplication();
    };

    const showAddUser = ref(false);
    const userCreated = () => {
      showAddUser.value = false;
      getApplication();
    };

    const addListAdmins = ref(false);

    const type = ref(["", "info", "success", "warning", "danger"]);
    const notifyVue = (verticalAlign, horizontalAlign, message) => {
      root.$notify({
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type.value[2],
      });
    };

    const errorNotifyVue = (verticalAlign, horizontalAlign, message) => {
      root.$notify({
        message: message,
        icon: "error",
        horizontalAlign: "right",
        verticalAlign: "top",
        type: type.value[4],
      });
    };

    const conflictedUsersList = ref([]);
    const showConflictUsersDialog = ref(false);
    const numberOfConflictedUsers = ref(0);

    const invalidatedUsersList = ref([]);
    const showInvalidatedUsersDialog = ref(false);
    const numberOfInvalidatedUsers = ref(0);

    const isWritable = computed(() => {
      return !application.value.isDeleted && !window.localStorage.getItem("adminGroups").includes("viewer_admins");
    });

    const isValidRegex = (regex) => {
      try {
        new RegExp(regex);
        return true;
      } catch (e) {
        return false;
      }
    }


    // Startup
    onMounted(() => {
      getApplication();
      getPolicies();
    });

    return {
      application,
      stats,
      applicationId,

      getApplication,

      originIPErrorMessage,
      normalizationPatternErrorMessage,
      editApplication,

      showSkey,
      toggleShowSkey,
      copyKey,

      showDeleteDialog,
      deleteDialogKey,
      deleteApplication,

      policy,
      getPolicies,
      setPolicy,

      showAppAdmins,
      adminAdded,

      showAddUser,
      userCreated,

      addListAdmins,

      notifyVue,

      conflictedUsersList,
      showConflictUsersDialog,
      numberOfConflictedUsers,

      invalidatedUsersList,
      showInvalidatedUsersDialog,
      numberOfInvalidatedUsers,

      isWritable,

      enableNormalizationUsernames,
    };
  },

  computed: {
    originIPMessageClass() {
      return {
        "md-invalid": this.originIPErrorMessage,
      };
    },
    normalizationPatternClass() {
      return {
        "md-invalid": this.normalizationPatternErrorMessage,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.change-image {
  position: relative;
  color: saddlebrown;
  z-index: 1000000;
}

.md-list-item-text {
  overflow: auto !important;
}

.skey {
  overflow: auto;
}

.to-logs {
  padding-bottom: 8px;
  padding-top: 8px;
}

.md-theme-default a:not(.md-button).show-add-user-deleted-app,
.md-theme-default a:not(.md-button).show-add-user-deleted-app:hover {
  color: var(--md-theme-default-primary-on-background, gray) !important;
}

.cursor-class {
  cursor: pointer;
}

.md-field.md-has-textarea:not(.md-autogrow) .md-textarea {
  padding: 0;
}
</style>
